import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-nutritional',
  templateUrl: './nutritional.component.html',
  styleUrls: ['./nutritional.component.less']
})
export class NutritionalComponent {

  type = 'doughnut';
  data = {
    labels: ['Grupo 1', 'Grupo 2', 'Grupo 3', 'Grupo 4'],
    datasets: [
      {
        label: 'Dependente',
        data: [12, 13, 5, 41]
      }
    ],
  };
  options = {
    scales: {
      xAxes: [{
        gridLines: {
          offsetGridLines: true
        }
      }]
    }
  };
  dependentId: string;
  companyId: string;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.route.params.subscribe((params: Params) => {
      this.dependentId = params['id'];
      this.companyId = params['companyId'];
    });
  }

  desc() {
    this.router.navigate(['general/descricaoPiramide']);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/nutritional/nutritional.component.ts